export const getRequiredNotTextInputMessage = fieldName => `${fieldName} is not filled`;

export const getRequiredMessage = fieldName => `${fieldName} is blank`;

export const getInvalidMessage = fieldName => `${fieldName} is invalid`;

export const getMinDateMessage = fieldName => `${fieldName} should not be less than 01/01/1900`;

export const getROInvalidMessage = "Only numbers without spaces are allowed";
export const getNotTrimmedMessage = fieldName => `${fieldName} should not have trailing spaces`;
